import React, { useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";

/**
 * Celda que corta con puntos suspensivos y muestra el valor completo en un tooltip.
 *
 * EL TOOLTIP SOLO APARECE SI EL TEXTO NO ENTRA. Ponerlo siempre es peor que no
 * ponerlo: en una grilla de muchas filas, pasar el mouse para leer de arriba abajo
 * dispara un globo por celda repitiendo lo que ya se lee entero.
 *
 * Para saberlo hay que MEDIR, y se mide al entrar el mouse y no al renderizar: el
 * ancho de la celda depende del `flex` de la columna, del ancho de la grilla y de si
 * el usuario la redimensionó, así que un calculo al montar queda viejo enseguida.
 * `scrollWidth > clientWidth` es la comparacion: cuanto mide el contenido contra
 * cuanto se ve.
 *
 * Con `title` vacio MUI no dibuja nada, asi que el caso "entra completo" no cuesta un
 * nodo de mas.
 */
export default function CeldaTruncada({ value }) {
    const ref = useRef(null);
    const [cortado, setCortado] = useState(false);

    const texto = value ?? "";

    return (
        <Tooltip title={cortado ? String(texto) : ""} enterDelay={400}>
            <span
                ref={ref}
                onMouseEnter={() => {
                    const el = ref.current;
                    setCortado(Boolean(el) && el.scrollWidth > el.clientWidth);
                }}
                style={{
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100%",
                }}
            >
                {texto}
            </span>
        </Tooltip>
    );
}
